import React, { useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  showToast,
  useFormHandler,
} from "../../../../components";
import { useSelector } from "react-redux";
import { updateLeadCompany } from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const EditCompanyModal = ({ companyData, onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const validationRules = {
    companyName: { type: "text", required: true },
    url: { type: "text" },
    simplyHiredUrl: { type: "text" },
    zipRecruiterUrl: { type: "text" },
    glassDoorUrl: { type: "text" },
  };
  const { user } = useSelector((state) => state.auth);
  const initialFormData = {
    url: companyData?.url || "",
    companyName: companyData?.name || "",
    simplyHiredUrl: companyData?.simplyHiredUrl || "",
    zipRecruiterUrl: companyData?.zipRecruiterUrl || "",
    glassDoorUrl: companyData?.glassdoorUrl || "",
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  const handleSave = async () => {
    // const isValid = validateAllFields();
    // if (!isValid) return;
    const hasAtLeastOneUrl =
      formData.url?.trim() ||
      formData.simplyHiredUrl?.trim() ||
      formData.zipRecruiterUrl?.trim() ||
      formData.glassDoorUrl?.trim();

    if (!hasAtLeastOneUrl) {
      showToast("Please enter at least one company URL", "error");
      return;
    }

    try {
      setLoading(true);

      const res = await updateLeadCompany({
        coll: "LeadCompany",
        uiid: companyData?.id,
        payload: [
          {
            type: "SET",
            value: {
              name: formData.companyName,
              linkedInUrl: formData.url || null,
              simplyHiredUrl: formData.simplyHiredUrl || null,
              zipRecruiterUrl: formData.zipRecruiterUrl || null,
              glassdoorUrl: formData.glassDoorUrl || null,
            },
          },
        ],
      });

      if (res?.data) {
        showToast("Company updated successfully", "success");
        onCancel();
        if (onSuccess) onSuccess();
      } else {
        showToast("Failed to update company", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Something went wrong",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-5 p-4 sm:p-6">
      {/* <div className="w-full sm:w-1/2 lg:w-1/3">
                <FormFieldSet
                    type="search"
                    title="Search in existing company list"
                    placeholder="Search"
                    shadow={true}
                />
                <FormFieldSet
                    type="text"
                    title="URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.url}
                    onChange={(value) => handleChange("url", value)}
                    error={errors.url}
                />
            </div> */}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        <FormFieldSet
          type="text"
          title="Company Name"
          placeholder="Enter company name"
          shadow={true}
          value={formData.companyName}
          onChange={(value) => {
            setFormData((prev) => ({
              ...prev,
              companyName: value,
              // selectedCompany: "",
            }));
          }}
          required
          error={errors.companyName}
        />
        <FormFieldSet
          type="text"
          title="Company LinkedIn URL"
          shadow={true}
          placeholder="Enter"
          value={formData.url}
          onChange={(value) => handleChange("url", value)}
          error={errors.url}
          required
        />
        <FormFieldSet
          type="text"
          title="Company SimplyHired URL"
          shadow={true}
          placeholder="Enter"
          value={formData.simplyHiredUrl}
          onChange={(value) => handleChange("simplyHiredUrl", value)}
          error={errors.simplyHiredUrl}
        />
        <FormFieldSet
          type="text"
          title="Company ZipRecruiter URL"
          shadow={true}
          placeholder="Enter"
          value={formData.zipRecruiterUrl}
          onChange={(value) => handleChange("zipRecruiterUrl", value)}
          error={errors.zipRecruiterUrl}
        />
        <FormFieldSet
          type="text"
          title="Company Glassdoor URL"
          shadow={true}
          placeholder="Enter"
          value={formData.glassDoorUrl}
          onChange={(value) => handleChange("glassDoorUrl", value)}
          error={errors.glassDoorUrl}
        />
        {/* <FormFieldSet
                    type="text"
                    title="First Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.firstName}
                    onChange={(value) => handleChange("firstName", value)}
                    error={errors.firstName}
                />

                <FormFieldSet
                    type="text"
                    title="Last Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.lastName}
                    onChange={(value) => handleChange("lastName", value)}
                    error={errors.lastName}
                />

                <FormFieldSet
                    type="phone"
                    title="Phone"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.phone?.number || ""}
                    code={formData.phone?.code || ""}
                    onChange={(fullValue, details) =>
                        handleChange(`phone`, {
                            code: details.countryCode,
                            number: details.number,
                        })
                    }
                    error={errors.phone}
                />

                <FormFieldSet
                    type="text"
                    title="Email"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.email}
                    onChange={(value) => handleChange("email", value)}
                    error={errors.email}
                />

                <FormFieldSet
                    type="text"
                    title="Designation"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.designation}
                    onChange={(value) => handleChange("designation", value)}
                    error={errors.designation}
                /> */}
      </div>

      <div className="flex flex-col-reverse sm:flex-row justify-end items-center gap-3 mt-2">
        <Button
          variant="outlined"
          title="Cancel"
          color="black"
          onClick={() => onCancel()}
          className="w-full sm:w-auto"
        />
        <Button
          title="Save"
          variant="contained"
          color="primary"
          className="w-full sm:w-auto"
          onClick={() => handleSave()}
        />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default EditCompanyModal;
